import * as React from "react";

function SvgExport(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" width={24.824} height={24.798} {...props}>
        <g data-name="Group 10967">
          <g data-name="Group 10965">
            <path
              data-name="Path 43329"
              d="M23.77 24.995H.962A.961.961 0 010 24.033V.962A.961.961 0 01.962 0H23.77a.961.961 0 01.962.962V4.45h-1.923V1.923H1.921v21.154h20.888v-1.99h1.923v2.952a.962.962 0 01-.962.956z"
              fill="#3c4252"
            />
          </g>
          <g data-name="Group 10966">
            <path data-name="Rectangle 3628" fill="#3c4252" d="M9.75 11.538h14.557v1.923H9.75z" />
          </g>
          <path data-name="Path 43330" d="M20.282 8.408v8.05l5.228-4.025z" fill="#3c4252" />
        </g>
      </svg>
    </span>
  );
}

export default SvgExport;
